import image from './entertainment-tutor-1.png'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default ({ alt }): React.ReactElement => <img src={image} alt={alt} />
